import { type EntityType } from "features/common/types";
import { useMemo } from "react";
import { useSearchParams } from "react-router-dom";
import { getIndividualAssetUrl } from "../utils/assetUrlUtils";
import { useTranslation } from "react-i18next";

export const useFromAdminErrorAction = (
  entityType: EntityType,
  itemId: string | number | undefined,
  hasAccess: boolean | undefined,
) => {
  const { t } = useTranslation(["assets", "application"]);
  const [searchParams] = useSearchParams();
  const assetId = Number(itemId);

  const shouldDisplayAction = searchParams.get("fromAdmin") === "true" && hasAccess === false && assetId !== undefined;

  const action = useMemo<(() => void) | undefined>(() => {
    if (shouldDisplayAction) {
      const copy = assetId; // Prevent undefined error
      return () => window.open(`${getIndividualAssetUrl(entityType, +copy)}/configuration`, "_blank");
    }
    return undefined;
  }, [assetId, entityType, shouldDisplayAction]);

  const message = useMemo(() => {
    if (shouldDisplayAction) {
      return t("access.restrictedFromAdmin.description", { ns: "assets" });
    }
    return "";
  }, [shouldDisplayAction, t]);

  return { action, message, actionText: t("common.goBack", { ns: "application" }) };
};
